export type TraderRouteVersion = 'v1' | 'v2';

export function getTraderRouteVersion(pathname: string): TraderRouteVersion {
  const segments = pathname.split('/').filter(Boolean);

  if (segments[0] === 'user' && segments[2] === 'v1') {
    return 'v1';
  }

  if (segments[0] === 'user' && segments[2] === 'v2') {
    return 'v2';
  }

  if (segments[0] === 'api' && segments[1] === 'user' && segments[3] === 'v1') {
    return 'v1';
  }

  if (segments[0] === 'api' && segments[1] === 'user' && segments[3] === 'v2') {
    return 'v2';
  }

  return 'v2';
}

export function buildTraderDashboardPath(
  traderName: string,
  version: TraderRouteVersion = 'v2'
): string {
  return version === 'v1'
    ? `/user/${traderName}/v1`
    : `/user/${traderName}`;
}

export function buildTraderOpportunitiesPath(
  traderName: string,
  version: TraderRouteVersion = 'v2'
): string {
  return `${buildTraderDashboardPath(traderName, version)}/opportunities`;
}

export function buildTraderApiBasePath(
  traderName: string,
  version: TraderRouteVersion = 'v2'
): string {
  return version === 'v1'
    ? `/api/user/${traderName}/v1`
    : `/api/user/${traderName}/v2`;
}
